import React from 'react';
import { useI18n } from '@oneaudi/i18n-context';
import { messages } from '../../../i18n/messages';
import { Button } from './BackToSearch.styled';
import { handleOnClick, useHandleVisibility } from './BackToSearch.handlers';

type Props = {
  searchBarRef: React.RefObject<HTMLDivElement>;
  containerRef: React.RefObject<HTMLDivElement>;
  displayResultsLength: number;
};

export const BackToSearch = ({ searchBarRef, containerRef, displayResultsLength }: Props) => {
  const visible = useHandleVisibility(searchBarRef, containerRef, displayResultsLength);
  const labelText = useI18n(messages.back_to_search);
  const onClick = handleOnClick(searchBarRef);

  return visible ? (
    <Button onClick={onClick} icon="arrow-up" variant="primary" iconPosition="trailing">
      {labelText}
    </Button>
  ) : null;
};
